import matter from "gray-matter";
import ReactMarkdown from "react-markdown";
import { Subscribe } from "@components/MailChimp";

import Layout from "@components/Layout";
import getSlugs from "@utils/getSlugs";
import Anchor from "@components/Util/Anchor";
import { markDownStylesCss } from "@utils/markdown";

export default function BlogPost({ siteTitle, frontmatter, markdownBody }) {
  if (!frontmatter) return <></>;

  return (
    <>
      <Layout
        pageTitle={`${frontmatter.title} | ${siteTitle}`}
        description={frontmatter.description}
      >
        <div className="max-w-screen-xl m-auto p-4 md:p-8">
          <Anchor href="/blog">
            <button className="hover:shadow-lg font-bold py-2 px-4 rounded-md shadow-md text-gray-700 mb-8">
              ← Back to post list
            </button>
          </Anchor>
          <article>
            <h1 className="text-4xl font-bold line leading-10 mb-4">
              {frontmatter.title}
            </h1>
            {/* {frontmatter.hero_image && (
              <img
                src={frontmatter.hero_image}
                className="hero"
                alt={frontmatter.title}
              />
            )} */}
            <div className="blog-post">
              <ReactMarkdown source={markdownBody} />
            </div>
            <Subscribe />
          </article>
        </div>
      </Layout>
      <style jsx global>
        {markDownStylesCss}
      </style>
    </>
  );
}

export async function getStaticProps({ ...ctx }) {
  const { postname } = ctx.params;

  const content = await import(`../../posts/${postname}.md`);
  const config = await import(`../../siteconfig.json`);
  const data = matter(content.default);

  return {
    props: {
      siteTitle: config.title,
      frontmatter: data.data,
      markdownBody: data.content,
    },
  };
}

export async function getStaticPaths() {
  const blogSlugs = ((context) => {
    return getSlugs(context);
  })(require.context("../../posts", true, /^posts\/.*\.md$/));

  const paths = blogSlugs.map((slug) => `/post/${slug}`);

  return {
    paths, // An array of path names, and any params
    fallback: false, // so that 404s properly appear if something's not matching
  };
}
